import { useState } from 'react'

const useDeliveryMethodInfoDrawer = () => {
  const [showDeliveryMethodInfoDrawer, setShowDeliveryMethodInfoDrawer] = useState(false)

  const openDeliveryMethodInfoDrawer = () => {
    setShowDeliveryMethodInfoDrawer(true)
  }

  const closeDeliveryMethodInfoDrawer = () => {
    setShowDeliveryMethodInfoDrawer(false)
  }

  return {
    showDeliveryMethodInfoDrawer,
    setShowDeliveryMethodInfoDrawer,
    openDeliveryMethodInfoDrawer,
    closeDeliveryMethodInfoDrawer,
  }
}

export default useDeliveryMethodInfoDrawer
